import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { AppButton, Box, Inscription, RoundDoneIcon } from '@common-fe/common-fe';

import ROUTES from '@/common/routes';
import { ModalWrapper } from '@/components/wrappers';
import { useHistory } from '@/modules/core/hooks';

interface Props {
  onSetVisible: (value: boolean) => void;
}

const EmailSuccessfullyVerifiedModal: React.FC<Props> = ({ onSetVisible }) => {
  const { t } = useTranslation();
  const { push } = useHistory();

  const handleGoToAccountProfile = useCallback(() => {
    push(ROUTES.MANAGE_PROFILE);
  }, [push]);

  const handleGoToHomeDashboard = useCallback(() => {
    onSetVisible(false);
  }, [onSetVisible]);

  return (
    <ModalWrapper testId="SuccessfulAuthentication" visible onSetVisible={onSetVisible}>
      <Box pad={{ vertical: 'spacing24' }} align="center">
        <RoundDoneIcon size="48px" />

        <Inscription margin={{ top: 'spacing12' }} size="2xl" weight={700}>
          {t('Success')}
        </Inscription>

        <Inscription margin={{ top: 'spacing12' }}>
          {t('Your email address has been verified!')}
        </Inscription>
        
        <Box
          margin={{ top: 'spacing24' }}
          direction="row"
          justify="center"
          width="100%"
        >
          <Box width={{ width: '100%', max: '210px' }}>
            <AppButton
              buttonType="secondary"
              width="100%"
              onClick={handleGoToAccountProfile}
            >
              {t('Go to Account Profile')}
            </AppButton>
          </Box>
          <Box width={{ width: '100%', max: '210px' }} margin={{ left: 'spacing12' }}>
            <AppButton
              width="100%"
              onClick={handleGoToHomeDashboard}
            >
              {t('Go to Home Dashboard')}
            </AppButton>
          </Box>
        </Box>
      </Box>     
    </ModalWrapper>
  );
};

export default EmailSuccessfullyVerifiedModal;
